import { c as _c } from "react/compiler-runtime";
import Autoplay from "embla-carousel-autoplay";
import useEmblaCarousel from "embla-carousel-react";
import { useCallback, useEffect, useState } from "react";
export function useImageSlider(slideCount) {
  const $ = _c(26);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      loop: true
    };
    t1 = [Autoplay({
      delay: 6000,
      stopOnInteraction: true
    })];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  const [emblaRef, emblaApi] = useEmblaCarousel(t0, t1);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxIndex, setLightboxIndex] = useState(0);
  let t2;
  if ($[2] !== emblaApi) {
    t2 = () => {
      if (!emblaApi) {
        return;
      }
      setSelectedIndex(emblaApi.selectedScrollSnap());
    };
    $[2] = emblaApi;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const onSelect = t2;
  let t3;
  let t4;
  if ($[4] !== emblaApi || $[5] !== onSelect) {
    t3 = () => {
      if (!emblaApi) {
        return;
      }
      emblaApi.on("select", onSelect);
      onSelect();
      return () => {
        emblaApi.off("select", onSelect);
      };
    };
    t4 = [emblaApi, onSelect];
    $[4] = emblaApi;
    $[5] = onSelect;
    $[6] = t3;
    $[7] = t4;
  } else {
    t3 = $[6];
    t4 = $[7];
  }
  useEffect(t3, t4);
  let t5;
  if ($[8] !== emblaApi) {
    t5 = index => emblaApi?.scrollTo(index);
    $[8] = emblaApi;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const scrollTo = t5;
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = index_0 => {
      setLightboxIndex(index_0);
      setLightboxOpen(true);
    };
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const openLightbox = t6;
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => setLightboxOpen(false);
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  const closeLightbox = t7;
  let t8;
  if ($[12] !== slideCount) {
    t8 = () => setLightboxIndex(i => (i - 1 + slideCount) % slideCount);
    $[12] = slideCount;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  const lightboxPrev = t8;
  let t9;
  if ($[14] !== slideCount) {
    t9 = () => setLightboxIndex(i_0 => (i_0 + 1) % slideCount);
    $[14] = slideCount;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  const lightboxNext = t9;
  let t10;
  if ($[16] !== lightboxIndex || $[17] !== lightboxNext || $[18] !== lightboxOpen || $[19] !== lightboxPrev) {
    t10 = {
      open: lightboxOpen,
      index: lightboxIndex,
      onOpen: openLightbox,
      onClose: closeLightbox,
      onPrev: lightboxPrev,
      onNext: lightboxNext
    };
    $[16] = lightboxIndex;
    $[17] = lightboxNext;
    $[18] = lightboxOpen;
    $[19] = lightboxPrev;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== emblaRef || $[22] !== scrollTo || $[23] !== selectedIndex || $[24] !== t10) {
    t11 = {
      emblaRef,
      selectedIndex,
      scrollTo,
      lightbox: t10
    };
    $[21] = emblaRef;
    $[22] = scrollTo;
    $[23] = selectedIndex;
    $[24] = t10;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  return t11;
}